import PeChip from '@pe-libs/react-components/build/components/PeChip';
import React, { FC } from 'react';
import useStyles from './styles';

type Props = {
  offers: string[];
};

const Labels: FC<Props> = ({ offers }) => {
  const styles = useStyles();

  if (!offers) {
    return null;
  }

  return (
    <div className={styles.labelsContainer}>
      {offers.map((offer) => (
        <PeChip
          key={offer}
          color="greyLight"
          label={offer}
          clickable={false}
          onClick={(event: React.MouseEvent<HTMLDivElement, MouseEvent>) => event.stopPropagation()}
        />
      ))}
    </div>
  );
};

export default Labels;
